import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { useCreateUserWithEmailAndPassword } from 'react-firebase-hooks/auth';
import { Link, useNavigate } from 'react-router-dom';
import auth from '../../firebase.init';
import Loading from '../Loading/Loading';
import SocialLogin from '../SocialLogin/SocialLogin';

const Register = () => {
     const navigate = useNavigate()
     const [
          createUserWithEmailAndPassword,
          user,
          loading,
          error,
     ] = useCreateUserWithEmailAndPassword(auth, { sendEmailVerification: true });

     if (loading) {
          return <Loading></Loading>
     }

     if (user) {
          navigate('/')
     }

     let errorElement;
     if (error) {

          errorElement = <p className='text-danger'>Error: {error.message}</p>


     }



     const handleRegister = event => {
          event.preventDefault();
          const name = event.target.name.value;
          const email = event.target.email.value;
          const password = event.target.password.value;
          createUserWithEmailAndPassword(email, password, name)


     }
     return (
          <div className='my-2 '>
               <h1 className='text-center'>This is Register </h1>
               <div className='w-50 mx-auto'>
                    <Form onSubmit={handleRegister}>
                         <Form.Group className="mb-3" controlId="formBasicEmail">
                              <Form.Control type="text" name="name" placeholder="Enter name" />
                         </Form.Group>
                         <Form.Group className="mb-3" controlId="formBasicEmail">
                              <Form.Control type="email" name="email" placeholder="Enter email" />
                         </Form.Group>
                         <Form.Group className="mb-3" controlId="formBasicPassword">
                              <Form.Control type="password" name="password" placeholder="Password" />
                         </Form.Group>
                         <p>{errorElement}</p>
                         <Button className='w-50 mb-3' variant="primary" type="submit">
                              Submit
                         </Button>
                         <SocialLogin></SocialLogin>

                    </Form>


                    <Link to='/login'>
                         <p className='text-decoration-none my-3'>Please Go Login Page</p>

                    </Link>
               </div>

          </div>

     );
};

export default Register;